import { EmployeeFeedbackQuestionDto, EmployeeFeedbackActiveAtAction } from "@/services/api/services";
import { defineStore } from "pinia";
import { computed, ref } from "vue";

export type EmployeeFeedbackQuestionPerActionType = {
    recordStartTime?: EmployeeFeedbackQuestionDto;
    recordEndTime?: EmployeeFeedbackQuestionDto;
    recordBreakStartTime?: EmployeeFeedbackQuestionDto;
    recordBreakEndTime?: EmployeeFeedbackQuestionDto;
};

export const useEmployeeFeedbackStore = defineStore("employeeFeedback", () => {
    const employeeFeedbackQuestions = ref<EmployeeFeedbackQuestionDto[]>([]);

    const employeeFeedbackQuestionPerAction = computed(() => {
        const questions: EmployeeFeedbackQuestionPerActionType = {
            recordStartTime: undefined,
            recordEndTime: undefined,
            recordBreakStartTime: undefined,
            recordBreakEndTime: undefined,
        };

        employeeFeedbackQuestions.value.forEach((question) => {
            if (question.activeAtActions.includes(EmployeeFeedbackActiveAtAction.recordStartTime)) {
                questions.recordStartTime = question;
            }
            if (question.activeAtActions.includes(EmployeeFeedbackActiveAtAction.recordEndTime)) {
                questions.recordEndTime = question;
            }
            if (question.activeAtActions.includes(EmployeeFeedbackActiveAtAction.recordBreakStartTime)) {
                questions.recordBreakStartTime = question;
            }
            if (question.activeAtActions.includes(EmployeeFeedbackActiveAtAction.recordBreakEndTime)) {
                questions.recordBreakEndTime = question;
            }
        });

        return questions;
    });

    return {
        employeeFeedbackQuestions,
        employeeFeedbackQuestionPerAction,
    };
});
